/* eslint-disable security/detect-object-injection */
import React, { useState, useRef, useContext } from 'react';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import SEO from '../components/SEO';
import LitImage from '../components/images/LitImage';
import GetSEOData from '../data/SEO';
import BadgeHeroSection from '../components/HeroSectionBadge';
import Modal from '../components/Modal';
import LitStructuredText from '../components/generic/LitStructuredText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faXTwitter,
  faInstagram,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';
import SimplePagePopUp from '../components/SimplePagePopUp';
import ContactUsForm from '../components/ContactUsForm';
import ActivityContext from '../context/ActivityContext';

const ContactUs = () => {
  const {
    contactUsHero,
    formDashes,
    speechBubble,
    speechMarks,
    formSubmitted,
  } = imageQuery();
  const { contactSubmitted, setContactSubmitted } = useContext(ActivityContext);
  const { title, description } = GetSEOData('contact-us');

  return (
    <div className="contact-us-container">
      <SEO title={title} description={description} />
      <BadgeHeroSection
        heading="We can't wait to hear from you"
        hidePostcodeSearch
        mode={'White'}
        layout={'Grid'}
        smallHeading="Get in touch"
        secondaryHeroImage={contactUsHero}
      />

      <div className="form-heading">
        <h3>Questions? Comments? Feedback? We love them all.</h3>
      </div>
      {!contactSubmitted && (
        <div className="get-in-touch-container">
          <div className="get-in-touch-inner">
            <h3>Give us a call:</h3>
            <p className="get-in-touch-number">
              <a href="tel:03304604610">0330 460 4610</a>
            </p>
            {/* <p>
                Email:{' '}
                <a href="mailto:support@litfibre.com">support@litfibre.com</a>
              </p> */}
            <p>
              Our Customer Support team is available 7 days a week, 8am - 8pm
            </p>
            <div className="contact-us-social-icons">
              <a href="https://www.facebook.com/LitFibreBroadband">
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a href="https://twitter.com/litfibre">
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
              <a href="https://www.instagram.com/lit_fibre/">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>
        </div>
      )}

      <ContactUsForm
        formDashes={formDashes}
        speechBubble={speechBubble}
        speechMarks={speechMarks}
        formSubmitted={formSubmitted}
      />
    </div>
  );
};

export default ContactUs;
const imageQuery = () =>
  useStaticQuery(graphql`
    {
      datoCmsSimpleWebsitePageModel(slug: { eq: "legal/privacy-policy" }) {
        title
        slug
        seo {
          description
          title
          twitterCard
          image {
            gatsbyImageData
          }
        }
        simpleModularContent {
          ...ModularSimpleHero
          ...ModularParagraph
          ...ModularSimpleContent
        }
      }
      formSubmitted: file(
        relativePath: { eq: "contact-us-images/ContactUsSuccess.png" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      contactUsHero: file(
        relativePath: { eq: "contact-us-images/ContactUs-original-hero.png" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      formDashes: file(
        relativePath: { eq: "contact-us-images/Form-top-right-pings.png" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      speechBubble: file(
        relativePath: { eq: "contact-us-images/SpeechBubble-right.png" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
      speechMarks: file(
        relativePath: { eq: "contact-us-images/Sppechmarks-left.png" }
      ) {
        name
        relativePath
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
          )
        }
        extension
        publicURL
      }
    }
  `);
